import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypeVariableNumber = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 40 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9898 13.8987L31.6072 16.0416C31.5524 16.3482 31.2858 16.5714 30.9743 16.5714H26.737L25.5126 23.4286H29.5202C29.9205 23.4286 30.2234 23.7904 30.1531 24.1844L29.7704 26.3273C29.7157 26.6339 29.449 26.8571 29.1376 26.8571H24.9003L24.0765 31.4701C24.0218 31.7767 23.7551 32 23.4437 32H21.267C20.8667 32 20.5637 31.6382 20.6341 31.2442L21.4175 26.8571H16.1335L15.3097 31.4701C15.255 31.7767 14.9883 32 14.6769 32H12.5002C12.0999 32 11.797 31.6382 11.8673 31.2442L12.6507 26.8571H8.64302C8.24279 26.8571 7.93985 26.4953 8.01018 26.1013L8.39285 23.9584C8.44758 23.6518 8.71423 23.4286 9.02568 23.4286H13.263L14.4874 16.5714H10.4798C10.0795 16.5714 9.77659 16.2096 9.84693 15.8156L10.2296 13.6727C10.2843 13.3661 10.551 13.1429 10.8624 13.1429H15.0997L15.9235 8.52988C15.9782 8.22327 16.2449 8.00001 16.5563 8H18.733C19.1333 8 19.4363 8.36182 19.3659 8.75584L18.5825 13.1429H23.8665L24.6903 8.52988C24.745 8.22327 25.0117 8.00001 25.3231 8H27.4998C27.9001 8 28.203 8.36182 28.1327 8.75584L27.3493 13.1429H31.357C31.7572 13.1429 32.0602 13.5047 31.9898 13.8987ZM16.7457 23.4286H22.0297L23.2541 16.5714H17.9702L16.7457 23.4286Z"
      />
    </SvgIcon>
  )
);

TypeVariableNumber.displayName = 'TypeVariableNumber';

export default TypeVariableNumber;
